import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef } from 'react';

import { cn } from '@air/utils-tailwind';

export type SelectSeparatorProps = RadixSelect.SelectSeparatorProps;

export const SelectSeparator = forwardRef<HTMLDivElement, SelectSeparatorProps>(
  ({ className, ...restOfProps }, forwardedRef) => {
    return (
      <RadixSelect.Separator
        className={cn('-mx-2 h-px w-full bg-grey-4', className)}
        data-testid="SELECT_SEPARATOR"
        {...restOfProps}
        ref={forwardedRef}
      />
    );
  },
);

SelectSeparator.displayName = 'SelectSeparator';
